import { combineReducers } from "redux";
import {
  RUNSHEETS_LIST_FETCHED,
  RUNSHEET_FETCHED,
  ADD_JOB,
  UPDATE_JOB_ORDER,
  UPDATE_RUNSHEET,
  GENERATE_RUNSHEET,
  RUNSHEET_CANCELLED,
  DUPLICATE_RUNSHEET,
  UPLOAD_RUNSHEET
} from "../types";

const byId = (state = {}, action) => {
  switch (action.type) {
    case RUNSHEETS_LIST_FETCHED:
      return {
        ...state,
        ...action.payload.entities.runsheets
      };
    case RUNSHEET_FETCHED:
      return {
        ...state,
        ...action.payload.entities.runsheets
      };
    case GENERATE_RUNSHEET: {
      const externalId = action.payload;
      return {
        ...state,
        [externalId]: { externalId, jobs: [] }
      };
    }
    case ADD_JOB: {
      const { runsheetExternalId, jobExternalId } = action.payload;
      // Look up the correct runsheet
      const runsheet = state[runsheetExternalId];

      return {
        ...state,
        [runsheetExternalId]: {
          ...runsheet,
          jobs: runsheet.jobs.concat(jobExternalId)
        }
      };
    }
    case UPDATE_JOB_ORDER: {
      const { runsheetId, jobIds } = action.payload;
      const runsheet = state[runsheetId];
      return {
        ...state,
        [runsheetId]: {
          ...runsheet,
          jobs: jobIds
        }
      };
    }
    case UPDATE_RUNSHEET: {
      const { runsheetId, attributes } = action.payload;
      const runsheet = state[runsheetId];

      return {
        ...state,
        [runsheetId]: {
          ...runsheet,
          ...attributes
        }
      };
    }
    case DUPLICATE_RUNSHEET: {
      return {
        ...state,
        ...action.payload.entities.runsheets
      };
    }
    case UPLOAD_RUNSHEET: {
      return {
        ...state,
        ...action.payload
      };
    }
    default:
      return state;
  }
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case RUNSHEETS_LIST_FETCHED: {
      return [...state, ...action.payload.result];
    }
    case DUPLICATE_RUNSHEET: {
      return [...state, action.payload.result];
    }
    default:
      return state;
  }
};

const paginate = (state = { runsheets: [], total: 0 }, action) => {
  switch (action.type) {
    case "GET_RUNSHEETS":
      return {
        runsheets: action.payload.runsheets,
        total: action.payload.total
      };
    case "UPDATE_VEHICLE": {
      const runsheets = state.runsheets.map(runsheet => {
        if (runsheet.id !== action.payload.runsheetId) {
          return runsheet;
        }

        const vehicle = Object.assign(
          {},
          runsheet.vehicle,
          action.payload.vehicle
        );
        return {
          ...runsheet,
          vehicle: { ...vehicle }
        };
      });

      return {
        runsheets,
        total: state.total
      };
    }
    case "REMOVE_VEHICLE": {
      const runsheets = state.runsheets.map(runsheet => {
        if (runsheet.id !== action.payload.runsheetId) {
          return runsheet;
        }

        const { vehicle, ...runsheetWithoutVehicle } = runsheet;
        return runsheetWithoutVehicle;
      });

      return {
        runsheets,
        total: state.total
      };
    }
    case RUNSHEET_CANCELLED: {
      const runsheetId = action.payload;
      const runsheets = state.runsheets.map(runsheet => {
        if (runsheet.id === runsheetId) {
          return { ...runsheet, status: "CANCELLED" };
        }

        return runsheet;
      });

      return {
        runsheets,
        total: state.total
      };
    }
    default:
      return state;
  }
};

const calendar = (state = [], action) => {
  switch (action.type) {
    case "GET_CALENDAR_RUNSHEETS":
      return action.payload.runsheets;
    case "UPDATE_VEHICLE": {
      const runsheets = state.map(runsheet => {
        if (runsheet.id !== action.payload.runsheetId) {
          return runsheet;
        }

        const vehicle = Object.assign(
          {},
          runsheet.vehicle,
          action.payload.vehicle
        );
        return {
          ...runsheet,
          vehicle: { ...vehicle }
        };
      });

      return runsheets;
    }
    case "REMOVE_VEHICLE": {
      const runsheets = state.map(runsheet => {
        if (runsheet.id !== action.payload.runsheetId) {
          return runsheet;
        }

        const { vehicle, ...runsheetWithoutVehicle } = runsheet;
        return runsheetWithoutVehicle;
      });

      return runsheets;
    }
    case RUNSHEET_CANCELLED: {
      const runsheetId = action.payload;
      const runsheets = state.map(runsheet => {
        if (runsheet.id === runsheetId) {
          return { ...runsheet, status: "CANCELLED" };
        }

        return runsheet;
      });

      return runsheets;
    }
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds, paginate, calendar });



// WEBPACK FOOTER //
// ./src/reducers/runsheetsReducer.js